export default {
  // navMenuItems Words
  dashboard: 'Dashboard',

  logout: 'Logout',

  global: {
    unlimited: 'Unlimited',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },

  // navbar actions
  navbar: {
    back: 'back',
    save: 'save'
  },

  // alert
  alert: {
    unsavedChanges: 'You have unsaved change, are you sure about leaving this page?',
    copy: 'Text copied!',
    duplicateRequest: {
      title: 'Warning',
      message: 'Your previous request is being processed, please wait'
    },
    error: {
      title: 'Error',
      accessDenied: 'Dont have access to this action',
      openingBalanceUnlock: 'Opening balance is unlock, please lock it.',
      contactSupport: 'Contact with support',
      print: 'The print request has error'
    },
    warning: {
      title: 'Warning',
      repeatedRequestText: 'Your previous request is being processed, please wait'
    },
    message: {
      title: 'Message',
      pleaseWait: 'Request sent. please wait...',
      saveChange: 'Change saved'
    }
  },

  // login page
  login: {
    title: 'Login',

    getPhoneNumberStepMessage1: 'Please enter your email. SMS password ',
    getPhoneNumberStepMessage2: '(five-digit code)',
    getPhoneNumberStepMessage3: 'will be sent to confirm your email.',
    phoneNumber: 'Phone Number',
    email: 'Email',
    phoneNumberIsNotValid: 'Email not entered correctly',
    phoneNumberIsNull: 'Email not entered',

    otpCodeSentStepMessage1: 'For ',
    otpCodeSentStepMessage2: 'A 5-digit code was sent. Please enter the code ',
    otpCodeIsNotValid: 'The validation code was not entered correctly',
    otpCodeIsNull: 'Authentication code not entered',
    retrieveTheCode: 'retrieve code',

    loginToPanel: 'Login to HRM panel {name}',
    resendOTPMessage: 'Choose one of the following methods to retrieve the code',
    otpCall: '{number} will be called in a few moments',
    resendOTPTypes: {
      resend: 'Resend',
      sms: 'SMS',
      tel: 'Contact'
    },

    otp: 'One Time password',
    otpSend: 'One Time password sent to {number}',

    getSuperAdminTokenStepMessage: 'Please enter your token.',
    token: 'system administrator token',

    buttons: {
      getOTPCode: 'Get Code',
      login: 'Login'
    },

    notification: {
      userNotFound: 'User not found with this phone number!',
      accessError: 'Access denied to system!',

      login: {
        title: 'Message',
        message: 'You have successfully logged in'
      },

      logout: {
        title: 'Message',
        message: 'You have successfully logged out'
      },

      forceLogout: {
        title: 'Message',
        message: 'Please log in again due to not using the system for a long time'
      }
    }
  },

  profile: {
    title: 'Profile',

    edit: {
      title: 'Edit profile'
    }
  },

  // users page
  users: {
    general: {
      labels: {
        name: 'Name',
        family: 'Family',
        email: 'Email',
        role: 'Role',
        totalTime: 'Working time',
        user: 'Responder'
      },

      notifications: {
        insert: {
          success: 'User created successfully',
          error: 'Create user has error'
        },
        edit: {
          success: 'User updated successfully',
          error: 'Edit user has error'
        },
        delete: {
          success: 'User deleted successfully',
          error: 'Delete user has error'
        },
        restore: {
          success: 'User restored successfully',
          error: 'Restore user has error'
        }
      },
      confirmations: {
        delete: {
          title: 'Delete user confirmation',
          body: 'Are you sure about delete {name}?'
        }
      }
    },

    list: {
      title: 'Users list',

      table: {
        header: {
          row: 'Row',
          name: 'Name',
          email: 'Email',
          totalTime: 'Working time',
          restore: 'Restore',
          delete: 'Delete'
        }
      }
    },

    trash: {
      title: 'Removed user list'
    },

    insert: {
      title: 'Create user'
    },

    edit: {
      title: 'Edit user'
    },

    profile: {
      title: 'User profile',

      actions: {
        whatsApp: 'whatsApp',
        call: 'Call'
      }
    }
  },

  // tasks page
  tasks: {
    general: {
      labels: {
        category: 'Category',
        description: 'Description',
        attachment: 'Attachment',
        startTime: 'Start time',
        endTime: 'End time',
        acceptedTime: 'Accepted time',
        hour: 'Hour'
      },

      notification: {
        insert: {
          success: 'Task created successfully',
          error: 'Create task has error'
        },
        edit: {
          success: 'Task updated successfully',
          error: 'Edit task has error'
        },
        accept: {
          success: 'Task accepted successfully',
          error: 'Accept task has error'
        }
      }
    },

    list: {
      title: 'Task list',

      table: {
        header: {
          row: 'Row',
          user: 'User',
          startTime: 'Start time',
          endTime: 'End time',
          description: 'Description',
          category: 'Category',
          time: 'Time'
        }
      }
    },

    insert: {
      title: 'Add new task'
    },

    edit: {
      title: 'Edit task'
    },

    accept: {
      title: 'Accept task'
    }
  },

  tickets: {
    menu: 'Tickets',
    title: 'Tickets',

    general: {
      statusTypes: {
        all: 'All',
        created: 'Created',
        portalResponse: 'Operator answer',
        appResponse: 'Client answer',
        pending: 'Pending',
        completed: 'Completed',
        canceled: 'Canceled'
      },

      sendStatusTypes: {
        send: 'Sent',
        notSend: 'Not sent'
      },

      seenStatusTypes: {
        seen: 'Seen',
        notSeen: 'Unseen'
      },

      labels: {
        all: 'All',
        selectType: 'Select the subject',
        service: 'Service',
        responder: 'Responder',
        subject: 'Ticket subject',
        message: 'Message',
        dynamicAttach: 'Attach {number}',
        insertAttach: 'New attachment',
        unknown: 'By system',
        operator: 'Operator'
      },

      placeholder: {
        subject: 'Enter the subject of your ticket',
        message: 'Enter the text of your ticket'
      },

      table: {
        header: {
          row: 'Row',
          department: 'Department',
          service: 'System name',
          subject: 'Subject',
          date: 'Created date',
          lastUpdate: 'Latest update',
          operatorName: 'Operator',
          creator: 'Creator',
          responder: 'Responder',
          status: 'Status',
          sendStatus: 'Send status',
          seen: 'Seen'
        }
      },

      notifications: {
        attachUpload: 'The file was uploaded',
        requestSend: 'Your request has been sent, please wait!',

        insert: {
          success: 'The ticket was created successfully',
          error: 'Insert ticket has error'
        },

        sendMessage: {
          success: 'The message was sent successfully',
          error: 'Send message has error'
        },

        changeOperator: {
          success: 'Ticket operator edited successfully',
          error: 'Edit ticket operator has error'
        },

        parseError: {
          service: 'The selected service is invalid!',
          subject: 'The selected Subject is not valid!',
          message: 'The text entered is invalid!',
          attachments: 'The selected attachment is invalid!',
          operator: 'The selected operator is not valid!'
        }
      },

      confirmations: {
        send: {
          title: 'Send message confirmation',
          body: 'Are you sure you want to send your message?'
        }
      },

      validators: {
        subject: 'The subject of the ticket was not entered correctly!',
        message: 'The message text was not entered correctly!',
        service: 'The service is not selected correctly!'
      }
    },

    list: {
      title: 'Tickets'
    },

    insert: {
      title: 'Create new ticket'
    },

    answer: {
      title: 'Add reply to ticket'
    },

    detail: {
      title: 'Ticket detail',

      labels: {
        ticketId: 'Ticket ',
        status: 'Ticket status: ',
        createdAt: 'Created date: ',
        lastUpdate: 'Last update: ',
        user: 'User',
        operator: 'Operator',
        setComplete: 'Resolved problem'
      }
    }
  },

  // draggable dynamic table

  // draggable dynamic table
  draggableDynamicTable: {

    filters: 'filters',

    activeFilters: {
      title: 'Applied filters'
    },

    setting: {
      showColumns: 'Show Columns'
    },

    notifications: {
      loading: 'Loading information ...',
      error: 'Error receiving information',
      empty: 'No information available'
    },

    actions: {
      print: 'Print',
      download: 'Download',
      setting: 'Table settings'
    }
  },

  // date picker
  datePicker: {
    labels: {
      submit: 'Confirm',
      cancel: 'cancel',
      now: 'now',
      nextMonth: 'next month',
      prevMonth: 'month ago'
    },

    formats: {
      date: 'jYYYY/jMM/jDD',
      dateTime: 'jYYYY/jMM/jDD HH:mm',
      time: 'HH:mm'
    }
  },

  // Button
  create: 'create'

}
